<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export const cubeAnimationVariants = cva('inline-block shrink-0', {
  variants: {
    size: {
      xs: 'size-20',
      sm: 'size-28',
      md: 'size-52',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type CubeAnimationVariants = VariantProps<typeof cubeAnimationVariants>

export interface CubeAnimationProps {
  size?: CubeAnimationVariants['size']
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'
import { useLottie } from '../useLottie'

const props = withDefaults(defineProps<CubeAnimationProps>(), {
  size: 'md',
})

const { player, animationData } = useLottie(() => import('./assets/cube.json'))
</script>

<template>
  <span
    data-slot="cube-animation"
    aria-hidden="true"
    :class="cn(cubeAnimationVariants({ size: props.size }), props.class)"
  >
    <component :is="player" v-if="player && animationData" :animation-data="animationData" />
  </span>
</template>
